// src/utils/paises.js
// Configuración central de países soportados.
// Para agregar un país nuevo: añadir una entrada en el objeto.

export const PAISES = {
  CO: { nombre: "Colombia",       moneda: "COP", locale: "es-CO", indicativo: "57",  decimales: 0, formatoTel: "300 123 4567" },
  PE: { nombre: "Perú",           moneda: "PEN", locale: "es-PE", indicativo: "51",  decimales: 2, formatoTel: "987 654 321" },
  EC: { nombre: "Ecuador",        moneda: "USD", locale: "es-EC", indicativo: "593", decimales: 2, formatoTel: "099 123 4567" },
  MX: { nombre: "México",         moneda: "MXN", locale: "es-MX", indicativo: "52",  decimales: 2, formatoTel: "55 1234 5678" },
  AR: { nombre: "Argentina",      moneda: "ARS", locale: "es-AR", indicativo: "54",  decimales: 2, formatoTel: "11 1234 5678" },
  CL: { nombre: "Chile",          moneda: "CLP", locale: "es-CL", indicativo: "56",  decimales: 0, formatoTel: "9 1234 5678" },
  BO: { nombre: "Bolivia",        moneda: "BOB", locale: "es-BO", indicativo: "591", decimales: 2, formatoTel: "712 34567" },
  PA: { nombre: "Panamá",         moneda: "USD", locale: "es-PA", indicativo: "507", decimales: 2, formatoTel: "6123 4567" },
  VE: { nombre: "Venezuela",      moneda: "VES", locale: "es-VE", indicativo: "58",  decimales: 2, formatoTel: "412 1234567" },
  PY: { nombre: "Paraguay",       moneda: "PYG", locale: "es-PY", indicativo: "595", decimales: 0, formatoTel: "981 123456" },
  UY: { nombre: "Uruguay",        moneda: "UYU", locale: "es-UY", indicativo: "598", decimales: 2, formatoTel: "9 1234 5678" },
  CR: { nombre: "Costa Rica",     moneda: "CRC", locale: "es-CR", indicativo: "506", decimales: 0, formatoTel: "8123 4567" },
  ES: { nombre: "España",         moneda: "EUR", locale: "es-ES", indicativo: "34",  decimales: 2, formatoTel: "612 345 678" },
  US: { nombre: "Estados Unidos", moneda: "USD", locale: "es-US", indicativo: "1",   decimales: 2, formatoTel: "555 123 4567" },
};

// País por defecto (cuando un tenant no tiene configuración, asumimos Colombia)
export const PAIS_DEFAULT = "CO";

// Lista ordenada para el dropdown del registro (Colombia primero por ser el mercado principal)
export const PAISES_DROPDOWN = [
  { codigo: "CO", nombre: "Colombia" },
  { codigo: "PE", nombre: "Perú" },
  { codigo: "EC", nombre: "Ecuador" },
  { codigo: "MX", nombre: "México" },
  { codigo: "AR", nombre: "Argentina" },
  { codigo: "CL", nombre: "Chile" },
  { codigo: "BO", nombre: "Bolivia" },
  { codigo: "PA", nombre: "Panamá" },
  { codigo: "VE", nombre: "Venezuela" },
  { codigo: "PY", nombre: "Paraguay" },
  { codigo: "UY", nombre: "Uruguay" },
  { codigo: "CR", nombre: "Costa Rica" },
  { codigo: "ES", nombre: "España" },
  { codigo: "US", nombre: "Estados Unidos" },
];

// Devuelve la config de un país. Si no existe, devuelve la de Colombia (failsafe).
export function getPais(codigo) {
  return PAISES[codigo] || PAISES[PAIS_DEFAULT];
}